export const FILES_WITHOUT_MIME: Record<string, string> = {
  md: 'text/markdown',
};

export const normalizeFile = (file: File): File => {
  if (file.type) return file;

  const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  const mimeType =
    FILES_WITHOUT_MIME[fileExtension] || 'application/octet-stream';

  return new File([file], file.name, { type: mimeType });
};
